export default "__VITE_ASSET__fff773d0__"